import courses from "../assets/icons/1400.svg";
import expert from "../assets/icons/expert.svg";
import succes from "../assets/icons/succes.svg";
import img1400 from "../assets/icons/1400+.svg";
import img1100 from "../assets/icons/1100+.svg";
import img800 from "../assets/icons/800+.svg";
import findcourse from "../assets/images/findcourse.png";
import play from "../assets/icons/play .svg";
import online from "../assets/icons/online-learning 1.svg";
import notes from "../assets/icons/notes 1.svg";
import touch from "../assets/icons/choices 1.svg";
import settings from "../assets/icons/technical-support 1.svg";
import card from "../assets/images/card1.png";
import doira from "../assets/images/card1-circle.png";
import mentor from "../assets/images/mentor.png";
import event from "../assets/images/event.png";
import blog from "../assets/images/blog.png";
import slider from "../assets/images/slider.png";

const data = {
  courses,
  expert,
  succes,
  img1400,
  img1100,
  img800,
  findcourse,
  play,
  online,
  notes,
  touch,
  settings,
  card,
  doira,
  mentor,
  event,
  blog,
  slider,
};

export default data